import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { PillButton } from '../PillButton';
import { SiblingFigure } from '../characters/SiblingFigure';
import { products } from '../../data/products';
interface PointScreenProps {
  onNext: () => void;
}
const WARM = '#F2A05A';
const needs = [{
  label: 'Control',
  product: 'Supreme',
  role: 'firstborn' as const
}, {
  label: 'Simplicity',
  product: 'Easy Match',
  role: 'middle' as const
}, {
  label: 'Efficiency',
  product: 'One Bulk Fill',
  role: 'youngest' as const
}];
export function PointScreen({
  onNext
}: PointScreenProps) {
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-322" data-mp="2anxtwb6j1sg">
      <Reveal data-id="element-323" data-mp="3ti8w6ff7x6pd">
        <h2 className="font-heading text-[34px] leading-[1] tracking-[-0.02em] text-white" data-id="element-324" data-mp="3tis3z3b5mepo">
          But here’s the thing...
        </h2>
      </Reveal>
      <Reveal delay={0.14} data-id="element-325" data-mp="2mztx2z9pgbaa">
        <p className="mt-5 font-heading text-[24px] leading-tight text-primary" data-id="element-326" data-mp="2i33f26ecb5m8">
          There is no best sibling.
        </p>
      </Reveal>
      <Reveal delay={0.24} data-id="element-327" data-mp="2iw4e12x7c08c">
        <p className="mt-2 font-body text-[17px] leading-relaxed text-white/70" data-id="element-328" data-mp="2isqhibb7yl8t">
          They are just good at different things.
        </p>
      </Reveal>

      <Reveal delay={0.34} className="mt-7" data-id="element-329" data-mp="28vls82m2u9ns">
        <div className="space-y-2" data-id="element-330" data-mp="28yzqozrmdypy">
          {needs.map((need, i) => <motion.div key={need.label} initial={{
          opacity: 0,
          x: -12
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4 + i * 0.12,
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex items-center gap-3 rounded-2xl bg-white/[0.06] px-4 py-2.5 ring-1 ring-white/10" data-id="element-331" data-mp="2dtvlg7o8r06r" data-mpi={i}>
              <SiblingFigure role={need.role} className="h-10 w-10 shrink-0" data-id="element-332" data-mp="1v4fgn85iwlkj" />
              <span className="font-body text-[14px] text-white" data-id="element-333" data-mp="1h5pirqavqhv4">
                Some cases need <span className="text-primary" data-id="element-334" data-mp="1l71e8cgfpxb8">{need.label.toLowerCase()}</span>.
              </span>
              <span className="ml-auto font-body text-[10px] uppercase tracking-[0.14em] text-white/40" data-id="element-335" data-mp="3ntpzhqinrmj6">
                {need.product}
              </span>
            </motion.div>)}

          {/* the caboose is not a "some cases" sibling — every case can run warm */}
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.78,
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex items-center gap-3 rounded-2xl px-4 py-2.5" style={{
          backgroundColor: 'rgba(242,160,90,0.12)',
          boxShadow: 'inset 0 0 0 1px rgba(242,160,90,0.4)'
        }} data-id="element-336" data-mp="3e1u1sgkhhyfh">
            <SiblingFigure role="caboose" className="h-10 w-10 shrink-0" data-id="element-337" data-mp="3stcbxxqnwyqx" />
            <span className="font-body text-[14px] text-white" data-id="element-338" data-mp="3sv5hf9pjhcxc">
              And <span style={{
              color: WARM
            }} data-id="element-339" data-mp="2lgsor163tnb2">every</span> case can run warm.
            </span>
            <span className="ml-auto font-body text-[10px] uppercase tracking-[0.14em] text-white/40" data-id="element-340" data-mp="2hc2tnej9scr7">
              Composite Warmer
            </span>
          </motion.div>
        </div>
      </Reveal>

      <Reveal delay={0.9} className="mt-7" data-id="element-341" data-mp="10xq8tuf9zthi">
        <p className="font-body text-[13px] leading-relaxed text-white/50" data-id="element-342" data-mp="15wjpfvpv00lw">
          {products.length - 1} siblings for different cases. One that makes all of
          them flow better.
        </p>
        <div className="mt-4" data-id="element-343" data-mp="1fmd08ui6gbp3">
          <PillButton tone="dark" full onClick={onNext} data-id="element-344" data-mp="1fl1n442udrlb">
            So then...
          </PillButton>
        </div>
      </Reveal>
    </div>;
}